import React from "react";
import { AccentText, DoodleStar, DoodleHeart } from "../brand";
import Button from "../Button";

const Herosection = () => {
  const handleDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent) || /Windows/i.test(userAgent)) {
      window.plausible("Play Store Click");
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";
    } else if (/iPad|iPhone|iPod|ios/.test(userAgent) && !window.MSStream) {
      window.plausible("App Store Click");
      window.location.href =
        "https://apps.apple.com/us/app/social-spectrum/id6473112455";
    } else {
      window.plausible("Play Store Click");
      window.open(
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile",
        "_blank"
      );
    }
  };

  return (
    <section className="bg-hero-wash relative w-full overflow-hidden pb-20 pt-14 md:pb-28 md:pt-20">
      <div
        className="bg-mist-halo pointer-events-none absolute -left-16 -top-16 h-72 w-72 rounded-full blur-3xl"
        aria-hidden="true"
      />
      <div
        className="bg-sun-glow pointer-events-none absolute bottom-28 left-6 h-56 w-56 rounded-full blur-3xl"
        aria-hidden="true"
      />
      <div
        className="bg-teal-glow pointer-events-none absolute bottom-28 -right-10 h-64 w-64 rounded-full blur-3xl"
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="flex flex-col items-start text-left lg:col-span-7">
            <div className="mb-4 inline-flex items-center gap-2 rounded-brand border border-cloud-mist bg-mist-chip px-3.5 py-1.5">
              <svg
                className="text-heart-teal shrink-0"
                fill="none"
                height="18"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                width="18"
                aria-hidden="true"
              >
                <path d="M12 22C12 22 13 14 20 10C16 10 13 12 12 14" />
                <path d="M12 14C11 11 8 9 4 10C11 14 12 22 12 22" />
                <path d="M12 22V3" />
              </svg>
              <AccentText tone="teal" className="!mb-0">
                A warm, inclusive community
              </AccentText>
            </div>

            <h1 className="mb-5 text-left font-headline text-3xl leading-tight tracking-tight text-spectrum-blue sm:text-4xl lg:text-5xl">
              <span className="font-light">Navigating</span>
              <span className="mt-1 block font-extrabold">
                Neurodiversity Together.
              </span>
            </h1>

            <p className="mb-8 max-w-[560px] text-left font-body text-base leading-relaxed text-muted md:text-lg">
              Where neurodivergence finds its village. Join a compassionate
              community, access expert resources, and build meaningful
              connections—all in one app.
            </p>

            <div className="flex w-full flex-wrap items-center justify-start gap-4">
              <Button
                type="button"
                variant="accent"
                size="md"
                onClick={handleDownload}
                id="hero-download-btn"
              >
                Download Now →
              </Button>
              <Button
                href="#features"
                id="hero-know-more-btn"
                variant="outlineOnLight"
                size="md"
              >
                Know More
              </Button>
            </div>
          </div>

          <div className="relative lg:col-span-5">
            <div className="relative mx-auto max-w-lg lg:max-w-none">
              <DoodleStar
                className="pointer-events-none absolute -right-5 -top-5 z-20"
                size={40}
              />
              <DoodleHeart
                className="pointer-events-none absolute -bottom-4 -left-4 z-20"
                size={36}
              />
              <div
                className="bg-mist-halo absolute -inset-3 -z-10 hidden rounded-3xl blur-xl sm:block"
                aria-hidden="true"
              />
              <div className="rounded-2xl border border-hairline bg-surface-white p-2.5 shadow-comfort">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/photos/hero-family-play.webp"
                  }
                  alt="Father and son laughing while playing with wooden toys on the living room floor"
                  className="block h-[360px] w-full rounded-brand object-cover sm:h-[420px] lg:h-[470px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Herosection;
